/**
 * @graphql agg
 */
import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const PremiumTrialEotQuery: GraphQLTaggedNode = graphql`
	query PremiumTrialEotQuery {
		license {
			billingSourceSystem
			trialEndDate
			__typename
		}
	}
`;
